export var getNumbers = function getNumbers(value) {
  return value.replace(/\D/g, '');
};